import serverAxiosInstance from '../../axios/Backend'
import * as actionTypes from './actionTypes'

const fetchNotificationSuccess = (notifications) => {
    return {
        type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
        notifications: notifications
    }
}

export const fetchMyNotifications = () => {
    return async (dispatch) => {
        try {
            const res = await serverAxiosInstance.get('/api/v2/notifications/users/me')
            const resData = res.data

            if (resData.status === 'success') {
                dispatch(fetchNotificationSuccess(resData.data.data))
            }
            else {
                console.log('fetchMyNotifications:: Something was wrong to fetch notification')
            }

        } catch (e) {
            if (e.response && e.response.data) {
                console.log(e.response.data)
            }
        }
    }

}

export const clearNotificationsState = () => {
    return {
        type: actionTypes.CLEAR_NOTIFICATIONS_STATE
    }
}

export const addNewNotification = (notificationObj)=>{
    return {
        type:actionTypes.ADD_NEW_NOTIFICATIONS,
        notificationObj:notificationObj
    }
}

export const deleteNotification = (notificationId) =>{
    return {
        type:actionTypes.DELETE_NOTIFICATION,
        notificationId:notificationId
    }
}

export const updateNotification = (notificationObj)=>{
    return {
        type:actionTypes.UPDATE_NOTIFICATION,
        notificationObj:notificationObj
    }
}